import { InjectionToken } from '@angular/core';
import { PrismLanguages } from '../models/prism-languages.model';

export let PRISM_LANGUAGES = new InjectionToken<PrismLanguages>('PrismLanguages');

export const languages: PrismLanguages = {
    bash: 'bash',
    css: 'css',
    html: 'html',
    java: 'java',
    javascript: 'javascript',
    js: 'js',
    markup: 'markup',
    mathml: 'mathml',
    sass: 'sass',
    scss: 'scss',
    shell: 'shell',
    svg: 'svg',
    ts: 'ts',
    typescript: 'typescript',
    xml: 'xml',
};
